module.exports = __webpack_public_path__ + "img/layout_vertical_icon.f9858d7f.svg";